import { Column, Control, Field, Input } from "@allxsmith/bestax-bulma";
import React, { useState } from "react";
import { formatDate, getFirstDayOfWeek } from "../utils";

function useWeekInput({ label, initialValue, weekly, disabled, callback }) {
  const [value, setValue] = useState(formatDate(initialValue) || "");

  const onChange = e => {
    setValue(e.target.value);
    if(callback) {
      callback();
    }
  }
  const setDate = date => {
    // const selected = new Date(date);
    // const value = weekly && selected ? formatDate(getFirstDayOfWeek(selected)) : date;
    // setValue(formatDate(value));
    // setValue(value);
  };
  const input = (
    <Column>
      <Field>
        <label className="label">{label}</label>
        <Control>
          <Input
            value={value}
            onChange={onChange}
            type={"date"}
            disabled={disabled}
          />
        </Control>
      </Field>
    </Column>
  );
  return [value, input, setValue];
}

export default useWeekInput;
